import clsx, { type ClassValue } from "clsx";

/** Join class names. Thin wrapper so components import one thing. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
